export default __webpack_public_path__ + "static/media/review_bg.bbe5081b.png";